(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-return-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var successState = document.querySelector('.return-form__success-state[data-form-success="true"]');
    if (successState) {
      var columnLeft = successState.closest('.column-left');
      if (columnLeft) {
        var step1 = columnLeft.querySelector('.return-form-step-1');
        var step2 = columnLeft.querySelector('.return-form-step-2');
        if (step1) {
          step1.classList.add('is-hidden');
        }
        if (step2) {
          step2.classList.add('is-visible');
        }
      }
    }

    var columnLeft = document.querySelector('.custom-return-form .column-left');
    if (!columnLeft) return;

    columnLeft.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.classList.contains('return-form__form')) return;

      event.preventDefault();

      var step1 = columnLeft.querySelector('.return-form-step-1');
      var step2 = columnLeft.querySelector('.return-form-step-2');

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: {
          'Accept': 'text/html'
        }
      })
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var submittedSuccess = doc.querySelector('.return-form__success-state[data-form-success="true"]');

          if (submittedSuccess) {
            if (step1) step1.classList.add('is-hidden');
            if (step2) step2.classList.add('is-visible');
            form.reset();
          } else {
            form.submit();
          }
        })
        .catch(function () {
          form.submit();
        });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /* Scroll to hash on load */
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /* Preserve native Shopify filters when using category tag links */
  document.addEventListener('click', function (e) {
    const link = e.target.closest('.collection-category-filter a');
    if (!link) return;

    const currentUrl = new URL(window.location.href);

    if (!currentUrl.search) return;

    const targetUrl = new URL(link.href, window.location.origin);

    currentUrl.searchParams.forEach((value, key) => {
      if (key !== 'page') {
        targetUrl.searchParams.append(key, value);
      }
    });

    e.preventDefault();
    window.location.href = targetUrl.toString();
  });

  /* ================================
     AJAX PAGINATION
  ================================= */
  document.addEventListener('click', function (e) {
    const link = e.target.closest('.custom-pagination a');
    if (!link) return;

    e.preventDefault();

    const resultsList = document.querySelector('results-list');
    const sectionId = resultsList?.getAttribute('section-id');
    if (!sectionId) return;

    const url = new URL(link.href);

    resultsList.classList.add('loading');

    fetch(`${url.pathname}?section_id=${sectionId}&${url.searchParams}`)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newContent = doc.querySelector('#ResultsListContent');
        const currentContent = document.querySelector('#ResultsListContent');

        if (newContent && currentContent) {
          currentContent.innerHTML = newContent.innerHTML;

          window.history.pushState({}, '', link.href);

          currentContent.scrollIntoView({ behavior: 'smooth' });
        }

        resultsList.classList.remove('loading');
      })
      .catch(err => {
        console.error('Pagination error:', err);
        resultsList.classList.remove('loading');
      });
  });

  } catch(e) { console.error(e); }
})();
})();
